import React, { useState, useEffect } from "react";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { IoCloseSharp, IoClose, IoEye } from "react-icons/io5";
import { MdAddToPhotos, MdSearch } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import Loader2 from "../DashboardComponents/Loader/Loader2";
import { API_URL } from "../../Api/config";
import Button from 'react-bootstrap/Button';
import { addinventory, getinventory, getinventorybyid, deleteInventoryApi, getInventoryByType, getbrands, addbranddata, upateInventory, getitemcetogory, getsearchdata } from "../../Api/inventoryApi";
import CustomSelect from "../FollowUps/SelectBar";
import { Form } from "react-bootstrap";

function Inventory() {

    const [show, setShow] = useState(false);
    const [apicallupate, setApicallUpate] = useState(false);
    const [brandname, setBrandName] = useState('');
    const [buttonshow, setButtonShow] = useState(false);

    const handleCloseConfirmation = () => setShowConfirmation(false);
    const handleShowConfirmation = () => setShowConfirmation(true);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [show3, setShow3] = useState(false);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [inventoryData, setInventoryData] = useState({
        Make: '',
        ModelName: '',
        Price: '',
        VideoUrl: '',
    });

    const handleClose = () => {
        setShow(false);
        setShowImage(null);
        setInventoryId(null);
        setInventoryData({
            Make: '',
            ModelName: '',
            Price: '',
            VideoUrl: '',
        });
    }

    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [inventory, setInventory] = useState([]);
    const [showimage, setShowImage] = useState(null);
    const [inventoryId, setInventoryId] = useState(null);
    const [makedata, setMakeData] = useState([]);

    const [pricevalidate, setpricevalidate] = useState(false);

    const [title, setTitle] = useState('');
    const [typeid, setTypeId] = useState('');

    const [branddata, setBrandData] = useState([]);
    const [filteredBrandData, setFilteredBrandData] = useState([]);
    const [search, setSearch] = useState('');

    const [validated, setValidated] = useState(false);

    const [selectedItems, setSelectedItems] = useState([]);
    const [validatedshow, setValidatedshow] = useState(false);

    const goBack = () => {
        window.history.back();
    }

    const [buttonNames, setButtonNames] = useState([
        { id: 1, name: "Driver" },
        { id: 2, name: "Wood" },
        { id: 3, name: "Hybrid" },
        { id: 4, name: "Iron" },
        { id: 5, name: "Wedge" },
        { id: 6, name: "Putter" },
        { id: 7, name: "Shaft" },
        { id: 8, name: "Grip" },
        { id: 9, name: "Brand" }
    ]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setInventoryData({
            ...inventoryData,
            [name]: value,
        });
    }

    const [image, setImage] = useState(null);

    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    }

    const submitdata = () => {
        setApicallUpate(true);

        if (inventoryData.Price === "") {
            setpricevalidate(true);
            setApicallUpate(false)
            return;
        }

        const formdata = new FormData();
        formdata.append('make', inventoryData.Make);
        formdata.append('model_name', inventoryData.ModelName);
        formdata.append('price', inventoryData.Price);
        formdata.append('vide_url', inventoryData.VideoUrl);
        formdata.append('image', image);
        formdata.append('type', title);
        formdata.append('type_id', typeid);

        addinventory(formdata).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
                setApicallUpate(false);
                setValidatedshow(true);
            } else {
                const data = response.data.data;
                setApicallUpate(false);
                handleClose();
                getInventory();
                setButtonShow(false);
                setInventoryData({
                    Make: '',
                    ModelName: '',
                    Price: '',
                    VideoUrl: '',
                });
                setValidatedshow(false);
            }
        }
        ).catch((err) => {
            console.log(err);
        }
        );
        // .finally(() => {
        //     setApicallUpate(false);
        //     handleClose();
        //     getInventory();
        //     setInventoryData({
        //         Make: '',
        //         ModelName: '',
        //         Price: '',
        //         VideoUrl: '',
        //     });
        //     setButtonShow(false);
        // })

    }

    const updatedata = () => {
        setApicallUpate(true);

        const formdata = new FormData();
        formdata.append('make', inventoryData.Make);
        formdata.append('id', inventoryId);
        formdata.append('model_name', inventoryData.ModelName);
        formdata.append('price', inventoryData.Price);
        formdata.append('vide_url', inventoryData.VideoUrl);
        formdata.append('image', image);
        formdata.append('type', title);
        formdata.append('type_id', typeid);

        upateInventory(formdata).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
            }
        }
        ).catch((err) => {
            console.log(err);
        }
        ).finally(() => {
            setApicallUpate(false);
            handleClose();
            getInventory();
        })

    }

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // or whatever you want as default
    const [totalPages, setTotalPages] = useState(1); // set from API response

    const getInventory = () => {
        setIsLoading(true);
        // const data = { pageNumber, pageSize };
        getinventory().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setInventory(data.items);
                setFilteredData(data.items);
                setTotalPages(data.totalPages); // Assuming your API returns total pages
            }
        }
        ).catch((err) => {
            console.log(err);
        }
        ).finally(() => {
            setIsLoading(false);
        })
    }

    useEffect(() => {
        getInventory();
        getbranddata();
        getitems();
    }, []);

    const getsingleInventory = (id) => {
        setIsLoading(true);
        const data = {
            id: id
        }
        getinventorybyid(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setInventoryData(data);
                setTitle(data.type);
                setShowImage(data.image);
                setInventoryId(data._id);
            }
        }
        ).catch((err) => {
            console.log(err);
        }
        ).finally(() => {
            setIsLoading(false);
            handleShow();
        });
    }

    const deleteInventory = () => {
        const data = {
            id: inventoryId
        }

        deleteInventoryApi(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setInventoryId(null);
            handleCloseConfirmation();
            getInventory();
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByType(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setMakeData(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        }
        ).finally(() => {
            setIsLoading(false);
            handleShow();
            handleClose2();
        });
    }

    const dropdownfittingOptions = [
        { value: '0', label: 'All' },
        { value: '1', label: 'Driver' },
        { value: '2', label: 'Wood' },
        { value: '3', label: 'Hybrid' },
        { value: '4', label: 'Iron' },
        { value: '5', label: 'Wedge' },
        { value: '6', label: 'Putter' },
        { value: '7', label: 'Shaft' },
        { value: '8', label: 'Grip' }
    ];

    const [fitting_typeKeyword, setFittingTypeKeyword] = useState(dropdownfittingOptions[0]);

    const handlefittingType = (option) => {
        setFittingTypeKeyword(option);

        //FITER THE DATA BASED ON FITTING TYPE

        const fitting_typeKeyword = option.value;
        const keyword = fitting_typeKeyword;

        if (keyword === 'all' || keyword === '' || keyword === '0') {
            setBrandData(filteredBrandData);
        } else {
            // const data = filteredBrandData.filter(item => item.item_type_id === keyword);
            // setBrandData(data);
            const data = filteredBrandData.filter(item => item.item_type_id.includes(parseInt(keyword)));
            setBrandData(data);
        }
    }
    // const dropdownStatusOptions = [
    //     { value: '0', label: 'Brand' },
    //     { value: '1', label: 'Active' },
    //     { value: '2', label: 'Inactive' }
    // ];

    const [selectedKeyword, setSelectedKeyword] = useState();


    const fittingStatusSelect = (option) => {
        setSelectedKeyword(option);
    }



    useEffect(() => {
        if (!selectedKeyword || !fitting_typeKeyword || !filteredData) return;

        const selectedKeywordValue = selectedKeyword.label || '';
        const fittingTypeKeywordValue = fitting_typeKeyword.label || '';

        const isSelectedKeywordAll = selectedKeywordValue.trim().toLowerCase() === 'all' || selectedKeywordValue === '';
        const isFittingTypeKeywordAll = fittingTypeKeywordValue.trim().toLowerCase() === 'all' || fittingTypeKeywordValue === '';

        if (isSelectedKeywordAll && isFittingTypeKeywordAll) {
            setInventory(filteredData);
        } else {
            let filtered = filteredData;

            if (!isSelectedKeywordAll) {
                filtered = filtered.filter(item =>
                    item.brand_name.toLowerCase().includes(selectedKeywordValue.toLowerCase())
                );
            }

            if (!isFittingTypeKeywordAll) {
                filtered = filtered.filter(item =>
                    item.type.toLowerCase().includes(fittingTypeKeywordValue.toLowerCase())
                );
            }

            setInventory(filtered);
        }
    }, [selectedKeyword, fitting_typeKeyword, filteredData]);




    const getbranddata = () => {
        getbrands().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setBrandData(data);
                setFilteredBrandData(data);
                if (data.length > 0) {
                    setSelectedKeyword(data[0]);
                }
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const handlesearch = (value) => {
        const lowercasedValue = value.toLowerCase();
        const filtered = filteredData.filter(item =>
            //fiter type and brand name ModelName Price 
            item.type.toLowerCase().includes(lowercasedValue) ||
            item.brand_name.toLowerCase().includes(lowercasedValue) ||
            item.ModelName.toLowerCase().includes(lowercasedValue) ||
            item.Price.toString().includes(lowercasedValue) // Convert Price to string
        );
        setInventory(filtered);
    }

    const submitbranddata = (event) => {
        setApicallUpate(true);
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setValidated(true);
            setApicallUpate(false);
        } else {
            event.preventDefault();
            const data = {
                brand_name: brandname,
                item_ids: selectedItems
            };
            addbranddata(data).then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                }
            }
            ).catch((err) => {
                console.log(err);
            }
            ).finally(() => {
                setApicallUpate(false);
                handleClose3();
                getbranddata();
                setBrandName('');
                setSelectedItems([])
                setButtonShow(false);
            })

        }
    }


    const [items, setItems] = useState([]);

    const getitems = () => {
        getitemcetogory().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setItems(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            // Add the id to the selectedItems array if the checkbox is checked
            setSelectedItems((prevSelectedItems) => [...prevSelectedItems, id]);
        } else {
            // Remove the id from the selectedItems array if the checkbox is unchecked
            setSelectedItems((prevSelectedItems) =>
                prevSelectedItems.filter((itemId) => itemId !== id)
            );
        }
    };

    const [apicallupate2, setApicallUpate2] = useState(false);

    const handlesearchdata = (e) => {
        e.preventDefault();
        setApicallUpate2(true);
        const data = {
            brand_name: brandname
        }

        getsearchdata(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setApicallUpate2(false);
                setButtonShow(true);
                setItems(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });

    }

    return (
        <>

            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <Modal size="lg" show={show} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{title}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="">
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='form-group-input'>
                                                    <select name="Make" style={{ textTransform: "capitalize" }} value={inventoryData?.Make} onChange={(e) => handleChange(e)} className="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" >
                                                        <option value='' disabled>Make</option>
                                                        {makedata.map((item) => (
                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='form-group-input'>
                                                    <input type="text" name="ModelName" value={inventoryData?.ModelName} onChange={(e) => handleChange(e)} className="form-control dashboard-input-box-3" placeholder="Enter Model Name..." />
                                                    {
                                                        validatedshow && <p className="text-danger" style={{ fontSize: "14px", color: "red" }}>Model already exists for this brand</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='form-group-input'>
                                                    <input type="text" name="Price" value={inventoryData?.Price} onChange={(e) => { handleChange(e); setpricevalidate(false) }} className="form-control dashboard-input-box-3" placeholder="Price..." />
                                                    {
                                                        pricevalidate && <p className="text-danger" style={{ fontSize: "14px", color: "red" }}>Please insert Amount.</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='form-group-input'>
                                                    <input type="text" name="VideoUrl" value={inventoryData?.VideoUrl} onChange={(e) => handleChange(e)} className="form-control dashboard-input-box-3" placeholder="Insert Video Url..." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* {!inventoryId && ( */}
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='form-group-input'>
                                                    <input type="file" onChange={handleImageChange} className="form-control dashboard-input-box-3 choose_file" placeholder="Choose File" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* )} */}
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='form-group-input'>
                                                    {showimage && <img className="inventory-image" src={API_URL + "inventory/" + showimage} alt="image" />}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='full-width-btn'>
                                            {!inventoryId ? (
                                                <button className="btn btn-primary btn-create" onClick={submitdata}>
                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Add Club</span>)}
                                                </button>
                                            ) : (
                                                <button className="btn btn-primary btn-create" onClick={updatedata}>
                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Club</span>)}
                                                </button>
                                            )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        {/* add brand modal here  */}
                        <Modal size="lg" show={show3} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{title}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose3} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="">
                                    <Form noValidate validated={validated} onSubmit={submitbranddata}>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className='form-group'>
                                                    <div className='form-group-input d-flex inventory_box'>
                                                        <input type="text" name="ModelName" value={brandname} onChange={(e) => { setBrandName(e.target.value); setButtonShow(false) }} className="form-control dashboard-input-box-3" placeholder="Enter Brand Name..." required />
                                                        <button className="" onClick={handlesearchdata}>{apicallupate2 ? (<Spinner animation="border" className="border-black" />) : (<FaSearch />)}</button>
                                                    </div>
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter a brand name.
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mb-4'>
                                            <div className='col-md-12'>
                                                <Form>
                                                    {items.map((item, index) => (
                                                        <div key={index} className="mb-3">
                                                            {
                                                                item.available === false ? (
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        id={`default-checkbox-${item._id}`}
                                                                        label={item.item_name}
                                                                        className="form_brand_checkbox"
                                                                        disabled={!item.available}
                                                                        checked={false}
                                                                        onChange={(e) => handleCheckboxChange(e, item.item_id)}
                                                                    />
                                                                ) : (
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        id={`default-checkbox-${item._id}`}
                                                                        label={item.item_name}
                                                                        className="form_brand_checkbox"
                                                                        disabled={!item.available || !buttonshow}
                                                                        // checked={item.available === false ? false : ''}
                                                                        onChange={(e) => handleCheckboxChange(e, item.item_id)}
                                                                    />
                                                                )
                                                            }
                                                        </div>
                                                    ))}
                                                </Form>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='full-width-btn'>
                                                <button className="btn btn-primary btn-create" type="submit" disabled={!buttonshow} >
                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Save</span>)}
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* add brand modal end here   */}

                        <Modal size="lg" centered show={show2} onHide={handleClose2} className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">Add Inventory</h3>
                                        <button type="button" className="btn-close" onClick={handleClose2} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className='modal-select-btn'>
                                    <div className='select-btn-list'>
                                        {buttonNames.map((item) => (
                                            <div className='select-btn-item' key={item.id}>
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary btn-select`}
                                                    onClick={() => {
                                                        setTitle(item.name);
                                                        setTypeId(item.id);
                                                        if (item.name === "Brand") {
                                                            handleShow3();
                                                            handleClose2();
                                                        } else {
                                                            getmakedata(item.id);
                                                        }
                                                    }
                                                    }
                                                >
                                                    {item.name}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showConfirmation}
                            onHide={handleCloseConfirmation}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to remove this Inventory?</h4>
                                    <div className="confirmation-buttons mt-4">
                                        <Button variant="danger" onClick={deleteInventory} >
                                            Yes
                                        </Button>
                                        {' '}
                                        <Button variant="secondary" onClick={() => {
                                            handleCloseConfirmation();
                                        }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>

                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-header-new">
                                                    <button type="button" className="btn-header-transparent">
                                                        <div className="border_box_view">
                                                            <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                                                </div>
                                                                <div className="box_text_content">
                                                                    <div className="big_text">Inventory</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <div className="header-left">
                                                        <button type="button" className="btn-header-transparent close-icon btn_color_green" onClick={handleShow2}>
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <svg fill="none" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1-.45-1-1v-12c0-.55-.45-1-1-1zm17-4h-12c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2zm-2 9h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3h-3c-.55 0-1-.45-1-1s.45-1 1-1h3v-3c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z" fill="#99ea24" /></svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="filter_header">
                                                    <div className="row">
                                                        <div className="col-xxl-8 col-xl-6 col-lg-6 col-md-12">
                                                            <div className="filter_search_box">
                                                                <div className="search_box">
                                                                    <input type="text" className="form-control filter_search_bar" value={search} onChange={
                                                                        (e) => {
                                                                            setSearch(e.target.value);
                                                                            handlesearch(e.target.value);
                                                                        }
                                                                    } placeholder="Search inventory..." />
                                                                    <button className="filter_search_btn">
                                                                        <FaSearch />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
                                                            <div className="dropdown-btn-list filter_dropdown_view">
                                                                <div className="btn-1">
                                                                    <CustomSelect options={dropdownfittingOptions}
                                                                        defaultSelected={fitting_typeKeyword}
                                                                        onSelect={handlefittingType}
                                                                        category="type"
                                                                    />
                                                                </div>
                                                                <div className="btn-2 brand_btn">
                                                                    <CustomSelect options={branddata}
                                                                        defaultSelected={selectedKeyword}
                                                                        onSelect={fittingStatusSelect}
                                                                        category="brands"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12">

                                                            <>
                                                                {
                                                                    inventory.length === 0 ? (
                                                                        <div className="tab-box-section notes-tab">
                                                                            <div className='no-data-img'>
                                                                                <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                                            </div>
                                                                            <div className="no-data-text">
                                                                                <h3>No data Found</h3>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                        : inventory.map((item, i) => {
                                                                            return (
                                                                                <>
                                                                                    <div className="build_number_box club-fitting-card inventory_box">
                                                                                        <div className="build_number_box_inner">
                                                                                            <div className="list_border_boxs">
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Item Type:</div>
                                                                                                            <div className="big_text">{item.type}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Brand:</div>
                                                                                                            <div className="big_text">{item.brand_name}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Model:</div>
                                                                                                            <div className="big_text">{item.ModelName}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="d-flex align-items-center">
                                                                                                <button className="transparent-btn" onClick={
                                                                                                    () => {
                                                                                                        setInventoryId(item._id);
                                                                                                        handleShowConfirmation();
                                                                                                    }
                                                                                                }>
                                                                                                    <div className="gab_icon ">
                                                                                                        <IoClose />
                                                                                                    </div>
                                                                                                </button>
                                                                                                <button className="transparent-btn" onClick={
                                                                                                    () => {
                                                                                                        getsingleInventory(item._id);
                                                                                                        getmakedata(parseInt(item.type_id));
                                                                                                        setInventoryId(item._id);
                                                                                                    }
                                                                                                }>
                                                                                                    <div className="collapsed">
                                                                                                        <div className="gab_icon" >
                                                                                                            <IoEye />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </>
                                                                            )
                                                                        })
                                                                }
                                                            </>
                                                        </div>
                                                        {/* <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec`}>
                                                            <div className="tab-box-section mb-3">
                                                                <div className='select-btn-list'>
                                                                    {buttonNames.map((item) => (
                                                                        <div className='select-btn-item' key={item.id}>
                                                                            <button
                                                                                type="button"
                                                                                className={`btn btn-primary btn-select`}
                                                                                onClick={() => {
                                                                                    setTitle(item.name);
                                                                                    getmakedata(item.id);
                                                                                }
                                                                                }
                                                                            >
                                                                                {item.name}
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                {/* <div className="pagination d-flex justify-content-between align-items-center mt-4">
                                                    <button
                                                        className="btn btn-light"
                                                        onClick={() => {
                                                            if (currentPage > 1) {
                                                                setCurrentPage(currentPage - 1);
                                                                getInventory(currentPage - 1, pageSize);
                                                            }
                                                        }}
                                                        disabled={currentPage === 1}
                                                        style={{ background: "#99ea24", border: "#99ea24" }}
                                                    >
                                                        Prev
                                                    </button>

                                                    <span className="mx-2">Page {currentPage} of {totalPages}</span>

                                                    <button
                                                        className="btn btn-light"
                                                        onClick={() => {
                                                            if (currentPage < totalPages) {
                                                                setCurrentPage(currentPage + 1);
                                                                getInventory(currentPage + 1, pageSize);
                                                            }
                                                        }}
                                                        disabled={currentPage === totalPages}
                                                        style={{ background: "#99ea24", border: "#99ea24" }}
                                                    >
                                                        Next
                                                    </button>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    );
}

export default Inventory;